import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationEngineRpm
} from 'services/equipmentSets/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectEngineRpm } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    calibrationId: CalibrationId;
}

interface ConnectedProps {
    engineRpm: CalibrationEngineRpm;
}

type Props = OwnProps & ConnectedProps;

export class EngineRpmTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { engineRpm } = this.props;

        return <TableCell>{engineRpm} RPM</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    engineRpm: makeSelectEngineRpm()
});

export default connect(mapStateToProps)(EngineRpmTableCellComponent);
